(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('FileDuplicationService', FileDuplicationService);

    FileDuplicationService.$inject = ['$q', '$mdDialog', '$rootScope'];

    function FileDuplicationService($q, $mdDialog, $rootScope) {
        var service = {
            handleDuplicateUpload: handleDuplicateUpload
        };

        return service;

        /**
         * Handles the duplicate upload functionality for thirdParty form
         * @param {Object} vm - The controller view model
         * @param {String} fieldKey - The field key being uploaded to
         * @param {Object} filePicker - The file picker object
         * @param {Function} saveFunction - The save function to call
         * @param {Function} accessByString - Helper function to access nested properties
         * @return {Promise} Promise that resolves when the operation is complete
         */
        function handleDuplicateUpload(vm, fieldKey, filePicker, saveFunction, accessByString) {
            var otherField = null;
            var confirmMessage = null;
            
            // Determine the other field and confirmation message
            if(fieldKey === 'report') {
                otherField = 'redactedReport';
                confirmMessage = 'Would you like to also upload this report as the Originator Report?';
            } else if(fieldKey === 'redactedReport') {
                otherField = 'report';
                confirmMessage = 'Would you like to also upload this report as the Lender Report?';
            }
            
            if(!otherField || !confirmMessage) {
                return $q.reject('Invalid field configuration');
            }

            // Show confirmation dialog
            var confirm = $mdDialog.confirm()
                .textContent(confirmMessage)
                .ariaLabel('uploadToBothFields')
                .ok('Yes')
                .cancel('No');

            return $mdDialog.show(confirm).then(function() {
                return duplicateFileToOtherField(vm, fieldKey, otherField, filePicker, saveFunction, accessByString);
            }, function() {
                // User cancelled - just save the original file
                return saveFunction(true);
            });
        }

        /**
         * Duplicates the file to the other field and saves
         * @param {Object} vm - The controller view model
         * @param {String} sourceField - The source field key
         * @param {String} targetField - The target field key
         * @param {Object} filePicker - The file picker object
         * @param {Function} saveFunction - The save function to call
         * @param {Function} accessByString - Helper function to access nested properties
         * @return {Promise} Promise that resolves when the save is complete
         */
        function duplicateFileToOtherField(vm, sourceField, targetField, filePicker, saveFunction, accessByString) {
            return $q(function(resolve, reject) {
                // Update the report data model synchronously
                accessByString(vm.reportData[vm.currentForm], targetField, filePicker[0].lfFile);

                // Make sure the other picker exists first
                if(!vm.filePickers[targetField]) {
                    vm.filePickers[targetField] = [];
                }

                // Clear any existing files via API if available
                if(vm.fileApis[targetField] && angular.isFunction(vm.fileApis[targetField].removeAll)) {
                    vm.fileApis[targetField].removeAll();
                }

                // Set flag to prevent recursive dialog when we add to the other picker
                vm.filePickers[targetField]._skipDuplicateDialog = true;

                // Replace current selection in the other picker
                vm.filePickers[targetField].length = 0;
                vm.filePickers[targetField].push(filePicker[0]);
                vm.filePickers[targetField].$dirty = true;
                
                // Synchronously update form data - no waiting needed
                if(vm.formData) {
                    vm.formData[targetField] = filePicker[0].lfFile;
                }

                // Use $evalAsync to defer until after current digest completes
                // This ensures the UI bindings have been updated before we save
                $rootScope.$evalAsync(function() {
                    // At this point, the digest cycle has completed and UI is consistent
                    // Pass the file directly to avoid any dependency on view binding state
                    chainSaveOperation(vm, targetField, saveFunction)
                        .then(resolve)
                        .catch(reject);
                });
            });
        }

        /**
         * Chains save operations properly by tracking the current save promise
         * @param {Object} vm - The controller view model
         * @param {String} targetField - The target field key
         * @param {Function} saveFunction - The save function to call
         * @return {Promise} Promise that resolves when the save is complete
         */
        function chainSaveOperation(vm, targetField, saveFunction) {
            // If already saving, wait for the current save to complete
            if(vm.isSaving && vm.currentSavePromise) {
                return vm.currentSavePromise.then(function() {
                    return saveFunction(true).then(function(result) {
                        resetSkipFlag(vm, targetField);
                        return result;
                    });
                });
            } else {
                // No save in progress, save immediately
                vm.currentSavePromise = saveFunction(true).then(function(result) {
                    resetSkipFlag(vm, targetField);
                    vm.currentSavePromise = null;
                    return result;
                });
                return vm.currentSavePromise;
            }
        }

        /**
         * Resets the skip flag for the target field
         * @param {Object} vm - The controller view model
         * @param {String} targetField - The target field key
         */
        function resetSkipFlag(vm, targetField) {
            if(vm.filePickers[targetField]) {
                vm.filePickers[targetField]._skipDuplicateDialog = false;
            }
        }
    }
})(); 